/**
 * Trading API
 * Re-exports appApi for trading
 */

import { appApi } from '@/infrastructure/api';

export { appApi };
export default appApi;

